// 消息管理API
import request from '@/utils/request'

// 获取消息列表
export const getMessageListApi = (data) => {
    return request({
        url: 'Notifications/List',
        method: 'post',
        data
    })
}

// 保存消息（添加/编辑）
export const saveMessageApi = (data) => {
    return request({
        url: 'Notifications/adminSave',
        method: 'post',
        data
    })
}

// 获取消息详情
export const getMessageDetailApi = (data) => {
    return request({
        url: 'Notifications/byData',
        method: 'post',
        data
    })
}
